import { createAction, props } from '@ngrx/store';

const GET_USER_STORIES = '[UserStories] Get UserStories';
const GET_USER_STORIES_SORTING = '[UserStories] Get UserStories With Sorting';
const SAVE_USER_STORIES = '[UserStories] Save UserStories';
const UPDATE_USER_STORIES = '[UserStories] Update UserStories';
const DELETE_USER_STORIES = '[UserStories] Delete UserStories';
const SAVE_USER_STORIES_ORDER = '[UserStories] Save UserStoriesOrder';
const SET_USER_STORIES = '[UserStories] Set UserStories';
const SET_USER_STORIES_ORDER = '[UserStories] Set UserStoriesOrder';
const DELETE_FILE_ATTACHMENTS = '[UserStories] Delete FileAttachments';
const SELECT_FILE_ATTACHMENTS = '[UserStories] Select FileAttachments';

const getUserStories = createAction(GET_USER_STORIES, props<{ apiConstants: any }>());
const getUserStoriesWithSorting = createAction(GET_USER_STORIES_SORTING, props<{ apiConstants: any; params: any }>());
const saveUserStories = createAction(SAVE_USER_STORIES, props<{ saveAPiConstants: any; userstoriesData: any }>());

const saveUserStoriesOrder = createAction(
  SAVE_USER_STORIES_ORDER,
  props<{ saveAPiConstants: any; userstoriesOrderData: any }>()
);

const updateUserStories = createAction(UPDATE_USER_STORIES, props<{ userstoriesData: any }>());

const setUserStories = createAction(SET_USER_STORIES, props<{ userStoriesTable: any }>());

const setUserStoriesOrder = createAction(SET_USER_STORIES_ORDER, props<{ userStoriesOrder: any }>());

const deleteUserStories = createAction(DELETE_USER_STORIES, props<{ deleteStoryApiConstants: any; ids: any }>());

const deleteFileAttachments = createAction(
  DELETE_FILE_ATTACHMENTS,
  props<{ deleteFileAttachmentApiConstants: any; fileAttachmentsId: any }>()
);

const selectFileAttachments = createAction(SELECT_FILE_ATTACHMENTS, props<{ response: any }>());

export {
  getUserStories,
  saveUserStories,
  updateUserStories,
  getUserStoriesWithSorting,
  deleteUserStories,
  saveUserStoriesOrder,
  setUserStories,
  setUserStoriesOrder,
  deleteFileAttachments,
  selectFileAttachments
};
